import SubscriptionStatus from "@/components/SubscriptionStatus/SubscriptionStatus.vue";
import InfoMessage from "../../components/AlertMessage/InfoMessage.vue";
import Preloader from "@/components/Preloader/Preloader.vue";
import LoaderMini from "../../components/LoaderMini/LoaderMini.vue";
import {mapGetters} from "vuex";
import axios from "axios";
import helper from "@/store/helpers/helper";
export default {
   name: 'PricingDetails',
   components: {SubscriptionStatus, InfoMessage, Preloader, LoaderMini},
   data() { return{
      paymentSystemCollection: [{name: "Paypal", status: true},{name: "Stripe", status: false}],
      selectPaymentSystem: "Paypal",
      plan: null,
      showPreloader: true,
      terminateStatus: null,
      updateSubscriptionStatus: null,
      showErrorMessage: false,
      cheaperMessage: false,
      serverErrorMessage: false,
   } },
   methods: {
      tooltipTextForMonthlyPlan () {
        if (this.userInfo.plan && this.plan.name === 'Monthly' && this.userInfo.plan.plan_name === 'Yearly') {
           return this.userInfo.plan.status === 'ACTIVE_UNTIL_PERIOD_END' ?
               'Your current subscription will remain active until ' + this.userInfo.plan.end_at.split(' ')[0] :
               'You currently have an active Yearly subscription'
        }
        return '';
      },
      redirectToLoginPage () {
         if (!this.isLoggedIn) {
            this.$router.push('/secure')
         }
      },
      updateSubscription() {
         this.updateSubscriptionStatus = 'loading'
         let dataUpdateSubscription_2 = {
            payment_system_name: "Paypal",
            currency_code: "USD",
            return_url: String(process.env.VUE_APP_URL + '/pricing/pay/success'),
            cancel_url: String(process.env.VUE_APP_URL + '/pricing'),
            plan_id: this.plan.dashboard_plan_id,
            subscription_id: (JSON.parse(localStorage.user).subscription_id)
         }

         axios
             .post(process.env.VUE_APP_API + '/dashboard-integration/payments/update', dataUpdateSubscription_2, {
                headers: {
                   'Authorization': localStorage.getItem('token')
                }
             })
             .then((resp) => {
                this.updateUserPlan(this.plan.dashboard_plan_id)
                this.updateSubscriptionStatus = 'success'
                document.location.href = resp.data.links[0].href
             })
             .catch(error => {

                if (error.response.data.message.indexOf('cheaper')) {
                   this.showErrorMessage = true
                   this.updateSubscriptionStatus = 'error'
                   this.cheaperMessage = true
                }
                if (error.response.status === 500) {
                   this.serverErrorMessage = true;
                }
             })
             .finally()
      },
      terminate_subscription() {
         this.terminateStatus = 'loading'
         setTimeout(()=> {
            this.$store.dispatch('terminate_subscription')
                .then((res) => {
                   this.terminateStatus = 'success'
                })
                .catch((err) => {
                   console.log(err)
                   this.terminateStatus = 'error'
                })
         }, 3000)
      },
      updateUserPlan(planId) {
         let storageUser = JSON.parse(localStorage.user)
         storageUser.user_plan = planId
         localStorage.setItem('user', JSON.stringify(storageUser))
      },
      choosePaymentSystem(arg) {
         this.selectPaymentSystem = arg
      },
      checkSubscriptionStatus(id) {
         if (this.userInfo) {
            return ( id === this.userInfo.plan.workspace_plan_id && this.userInfo.email_verified_at) ? 'active' : 'suspended'
         }
      },
      get_plan() {
         this.$store.dispatch('get_local_plans')
             .then((resp) => {
                this.plan = resp.data.filter(val => val.name.toLowerCase() === String(this.$route.params.plan_name))[0]
                if (!this.plan) {
                   this.$router.push('/not-found').then()
                }
             })
             .catch(error => {
                console.log(error);
             })
             .finally(() => (setTimeout(() => this.showPreloader = false, 500)));
      },
      choosePricingImageSrc: helper.choosePricingImageSrc,
   },
   created() {
      this.get_plan()
   },
   computed: mapGetters(['isLoggedIn','isActive', 'userInfo', 'getWidth'])
}
